import { Route, Switch } from 'wouter';
import InvoicesPage from '@/components/InvoicesPage/InvoicesPage';
import InvoiceDetailsPage from '@/components/InvoicesPage/InvoiceDetailsPage';
import FinalInvoicePage from '@/components/InvoicesPage/FinalInvoicePage';

export default function InvoicesPageWrapper() {
  return (
    <Switch>
      <Route path="/final/:id" component={FinalInvoicePage} />
      <Route path="/:id" component={InvoiceDetailsPage} />
      <Route path="/" component={InvoicesPage} />
    </Switch>
  );
}
